import React, { useEffect } from "react";

interface EditModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
  data: any;
  title: string;
}

const EditModal: React.FC<EditModalProps> = ({
  isOpen,
  onClose,
  onSave,
  data,
  title,
}) => {
  const [formData, setFormData] = React.useState(data);

  useEffect(() => {
    setFormData(data); // Update formData when data prop changes
  }, [data]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormData((prev: any) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSave(formData);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
      <div className="bg-white shadow-lg rounded-lg p-16 w-[430px] relative w-[95%] md:w-[40%]">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
          aria-label="Close"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 26 26"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <h2 className="font-ubuntu text-[24px] mb-[22px] font-[500] text-center">
          {title}
        </h2>
        <form onSubmit={handleSubmit} className="flex flex-col">
          {Object.keys(formData).map((key) => (
            <div key={key} className="mb-[20px]">
              <label
                htmlFor={key}
                className="block font-ubuntu text-gray-700 font-bold mb-2"
              >
                {key.charAt(0).toUpperCase() + key.slice(1)}
              </label>
              <input
                name={key}
                value={formData[key]}
                onChange={handleChange}
                type={key === "birthday" ? "date" : "text"}
                className="appearance-none font-ubuntu w-full py-[2px] text-gray-700 leading-tight focus:outline-none focus:shadow-outline border-b-[3px] border-gray-300 focus:border-blue-500"
                placeholder={`Enter ${
                  key.charAt(0).toUpperCase() + key.slice(1)
                }`}
              />
            </div>
          ))}
          <div className="flex justify-center">
            <button
              type="submit"
              className="bg-blue-500 w-[120px] h-[40px] font-ubuntu hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-full focus:outline-none focus:shadow-outline"
            >
              Done
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditModal;
